export default __webpack_public_path__ + "eefc32d982a2bfd55298e104c6531e8d.svg";